module.exports = __webpack_public_path__ + "images/noResultImage.d51347d8.svg";